import { Disclaimer, Div, Img, P, Separator } from '@vgrubs/components';

type Props = {
  image?: string | null;
  label: string;
  /** Small line under the name: "POS", or the access state. */
  caption?: string;
};

/**
 * Logo and name of one integration the restaurant told us about: its POS or a marketplace.
 * Without a logo the name stands alone, centered, so it is not printed twice.
 */
export const IntegrationTile = ({ image, label, caption }: Props) => (
  <Div
    $box
    $boxNoShadow
    $p="12px 16px"
    $flex
    $column
    $alignCenter
    $justifyCenter
    $width="140px"
  >
    {image && (
      <>
        <Div $flex $alignCenter $justifyCenter $height="40px">
          <Img src={image} $maxWidth="100px" $maxHeight="40px" />
        </Div>
        <Separator $m="8px 0" />
      </>
    )}
    <P $bold $center $mb="0" $capitalize>
      {label}
    </P>
    {caption && (
      <Disclaimer $center $m="0" $mt="2">
        {caption}
      </Disclaimer>
    )}
  </Div>
);
